import React, { Component } from "react";
import { FirestoreDocument, withFirestore } from "react-firestore";
import Textarea from "react-textarea-autosize";
import debounce from "lodash.debounce";

// import PropTypes from "prop-types";

export class LinkPage extends Component {
  state = {
    description: this.props.link.description,
  };

  onUpdate = debounce(() => {
    const { id } = this.props.link;
    const { description } = this.state;
    const doc = this.props.firestore.doc(`links/${id}`);
    return doc.set(
      {
        description,
      },
      { merge: true }
    );
  }, 250);

  render() {
    const { id, archivedAt, favIconUrl, title, url } = this.props.link;
    const { description } = this.state;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          height: "100vh",
          padding: "1rem",
          backgroundColor: "#DAE1E7",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            padding: "1em",
            maxWidth: "50rem",
            margin: "0 auto",
          }}
        >
          <a href={url || decodeURIComponent(id)} target="_blank">
            <h5
              className="mb-1"
              style={{
                display: "flex",
                alignItems: "center",
                color: "#22292F",
              }}
            >
              {favIconUrl && (
                <img src={favIconUrl} style={{ width: 16, marginRight: 4 }} />
              )}
              <span>{title || url || decodeURIComponent(id)}</span>
            </h5>
            {title && <div style={{ color: "#8795A1" }}>{url}</div>}
          </a>
          <Textarea
            className="form-control"
            style={{ flex: 1 }}
            // style={{ marginTop: 5, marginBottom: 10 }}
            // onFocus={onFocus}
            // onBlur={onBlur}
            value={description}
            // inputRef={ref => (this.textarea = ref)}
            onKeyPress={e => {
              if (e.key === "Enter" && !e.shiftKey) {
                // this.textarea.blur();
                // this.onUpdate.flush();
              }
            }}
            onChange={e =>
              this.setState({ description: e.target.value }, this.onUpdate)
            }
          />
        </div>
        {/* <pre style={{ flex: 1, padding: "1em" }}>
          {JSON.stringify(this.props.link, null, 2)}
        </pre> */}
      </div>
    );
  }
}
// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
// LinkPage.propTypes = {};

const LinkPageWithFirestore = withFirestore(LinkPage);

export default props => {
  return (
    <FirestoreDocument
      path={`links/${props.match.params.url}`}
      render={({ isLoading, data }) => {
        return isLoading ? (
          <div>Loading...</div>
        ) : (
          <LinkPageWithFirestore link={data} />
        );
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/LinkPage.js